import { Component, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UserService } from 'src/app/services/user.service';
import { EMAIL_PATTERN } from 'src/app/shared/regex-patterns';
import { IVerificationInterface, emptyVerificationInterface } from 'src/app/shared/models/verification.interface';
import { ClaimService } from 'src/app/services/claim.service';
import { PolicyService } from 'src/app/services/policy.service';
import { SspService } from 'src/app/services/ssp.service';
import { AuthService, IdToken } from '@auth0/auth0-angular';
import { LoginService } from 'src/app/services/login.service';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'upsc-happy-returns-landing',
  templateUrl: './happy-returns-landing.component.html',
  styleUrls: ['./happy-returns-landing.component.scss']
})
export class HappyReturnsLandingComponent {

  public currentStep: number = 0;
  public loading: boolean = false;
  emailForm: UntypedFormGroup;
  confirmFormGroup: UntypedFormGroup;
  systemError: boolean = false;
  verifyCodeError: boolean = false;
  public loading2: boolean = false;
  public createVerificationInterface: IVerificationInterface = emptyVerificationInterface;
  verifyCodeInterface = { emailId: "", toVerify: "" };
  public emailAddress: string = '';
  public policyNumber: string = '';
  public groupCode: string = '';
  public partnerCustomizationError: boolean = false;
  public partnerCustomizationPolicyNumber: string = '';
  public policyNotMatchError: boolean = false;
  appStateTarget = '';
  email: string = '';
  channelPartner: string = 'happy-returns';


  // @ViewChild("name1") field1: ElementRef;
  // @ViewChild("name2") field2: ElementRef;
  // @ViewChild("name3") field3: ElementRef;
  // @ViewChild("name4") field4: ElementRef;
  // @ViewChild("name5") field5: ElementRef;
  // @ViewChild("name6") field6: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private titleService: Title,
    private fb: UntypedFormBuilder,
    private router: Router,
    private userService: UserService,
    private claimService: ClaimService,
    private policyService: PolicyService,
    private sspService: SspService,
    private auth: AuthService,
    private loginService: LoginService
  ) {

  }


  ngOnInit(): void {
    this.checkPolicyExist();
    this.gatherAppState(); //Auth0
    this.determineLoginState();

    this.userService.setLocale('US');
    this.titleService.setTitle(`CCP Consumer Portal | Happy Returns`);
    this.emailForm = this.fb.group({
      //emailAddress: ['', Validators.compose([Validators.pattern(EMAIL_PATTERN), Validators.required])],
      recaptchaControl: [null, Validators.required]
      //terms: [false, Validators.requiredTrue]
    });


  }

  checkPolicyExist() {
    try {
      var guestLinkRequest = {
        policyNumber: '',
        partnerName: 'happy-returns'
      }
      this.policyService.checkPolicyExist(guestLinkRequest).subscribe(response => {
        if (response && response.data && response.message === 'Found' && response.data.portalType.toLowerCase() === 'cpp') {
          this.partnerCustomizationError = false;
          if (response.data.policyNumbers && response.data.policyNumbers.length > 0) {
            this.partnerCustomizationPolicyNumber = response.data.policyNumbers[0];
          }
        } else {
          //this.currentStep = 0;
          this.partnerCustomizationError = true;
        }
      });
    } catch {
      //this.currentStep = 0;
      this.partnerCustomizationError = true;
    }
  }

  //Gathers the app state from Auth0, which may have been set by another component when they called loginWithRedirect. We use this app state to determine where to send the user after a successful login. If there is no app state, we will send them to the redirect URL or dashboard later
  //Used in CCP/SSP/passwordless flows
  gatherAppState() {
    this.auth.appState$.subscribe(
      appState => {
        if (appState && appState?.target) {
          console.log("User was authenticated, navigating to appState target: " + appState.target);
          this.appStateTarget = appState.target;
          this.router.navigateByUrl(appState.target);
        }
      }
    );
  }

  determineLoginState() {
    this.auth.idTokenClaims$.pipe(take(1)).subscribe(
      (response: IdToken | null | undefined) => {
        // if (response && response.sub && response.sub.startsWith('email|')) {
        //   console.log("if sub starts with email, they authenticated through the passwordless flow. Should go to a passwordless flow... what was appstate?");
        //   this.gatherAppState();
        //   return;
        // }
        if (!response) {
          this.initiatePasswordlessAuth();
        }
        if (response != null && response.__raw && response != undefined) {
          sessionStorage.setItem('data', JSON.stringify(response));
          sessionStorage.setItem('access_token', response.__raw);
          sessionStorage.setItem('customized-claims-landing', JSON.stringify({ email: response.email }));
          sessionStorage.setItem('verifyData', JSON.stringify({ ...response, emailAddress: response.email }));
          this.email = response.email;
          let request = {
            id_token: response.__raw,
            workflow: this.channelPartner
          }
          this.loginService.passwordLess(request).subscribe(
            data => {
              if (!data) {  //Make sure not to do anything with a processed token if we already have an app State. app state should have already redirected

                return;
              }
            }, error => {
              this.loading = false;
              this.systemError = true;
            }
          );
          this.verifyResponse();
        }
        //Call policy API to retrieve policy AFTER we have an access token.
        //let route = sessionStorage.getItem('redirectpath');
        // let route = 'freightcenterinc';
        // console.log("Routing ", route);
        // this.router.navigateByUrl(route);
        //this.navigateToClaims();
      });
  }

  initiatePasswordlessAuth() {
    console.log("initiating");
    this.auth.loginWithRedirect({
      authorizationParams: {
        connection: 'email',
        redirect_uri: `${environment.baseUrl.web}callback`,
        //redirect_uri: `${'http://localhost:4200/'}callback`,
        'ext-connect': 'email' //additional param to indicate template to hide "sign up" and "login" text
      },
      appState: { target: `/${this.channelPartner}` }
    });
  }

  getStarted() {

    // if (this.emailForm.valid) {
    //   this.saveVerificationCode();
    // }
  }


  // saveVerificationCode() {
  //   this.createVerificationInterface.data.emailAddress = this.email.value;
  //   this.createVerificationInterface.emailFor = "CCPVerificationEmail";
  //   this.claimService.sendCCPVerificationCodeEmail(this.createVerificationInterface).subscribe(
  //     data => {
  //       if ((data.responseMessage).toLowerCase() === 'new verification code created' ||
  //         (data.responseMessage).toLowerCase() === 'code not yet expired') {
  //         this.loading = false;
  //         this.emailAddress = this.email.value;
  //         this.currentStep = 1;
  //       }
  //     }, error => {
  //       this.loading = false;
  //       this.systemError = true;
  //     }
  //   );
  // }

  // get email() { return this.emailForm.controls.emailAddress }

  verifyResponse() {
    // if ($event.isVerified && $event.message === 'verification code matched') {

      //Call policy API to retrieve policy AFTER we have an access token.
      let policyrequest = {
        PartnerName: 'happy-returns',
        PolicyNumber: ''
      }
      this.sspService.getPartnerPolicy(policyrequest).subscribe(
        response => {
          if (response && response?.data && response?.data?.policyNumbers?.length > 0) {
            this.partnerCustomizationPolicyNumber = response.data.policyNumbers[0];
            let request = {
              emailAddress: this.email
            };
            this.policyService.getPolicyGroupCodeDetails(request).subscribe(response => {
              if (response && response.data && response.data.policyNumber !== null && response.data.policyNumber === this.partnerCustomizationPolicyNumber) {
                this.policyNotMatchError = false;
                sessionStorage.setItem('happyReturnsInfo',
                  JSON.stringify({
                    email: this.email,
                    policyNumber: response.data.policyNumber,
                    groupCode: response.data.groupCode,
                    partnerName: 'happy-returns'
                  }));
                this.policyNumber = response.data.policyNumber;
                this.groupCode = response.data.groupCode;
                this.policySearch(this.policyNumber);
              } else {
                this.policyNotMatchError = true;
                this.currentStep = 0;
                /*sessionStorage.setItem('happyReturnsInfo',
                  JSON.stringify({
                    email: this.email.value,
                    policyNumber: '15914024-P0017044',
                    groupCode: 'SHEIN',
                    partnerName: 'happy-returns'
                  }));
                this.policyNumber = '15914024-P0017044';
                this.groupCode = 'SHEIN';
                this.policySearch(this.policyNumber);*/
              }
            });
          } else {
            //No policies found?
            this.currentStep = 0;
            this.systemError = true;
          }
        }, error => {
          //Critical error
          this.currentStep = 0;
          this.systemError = true;
        }
      );


    // } else if (!$event.isVerified && $event.message === 'cancel') {
    //   this.currentStep = 0;
    // }
  }


  policySearch(policyNumber: any) {
    this.userService.getPolicySearch(policyNumber).subscribe(
      policyData => {
        if (policyData?.message?.toLowerCase() != 'succeeded') {
          this.currentStep = 0;
          this.systemError = true;
          return;
        }
        //Continue
        let policy = policyData.data;
        this.setUserPermissions(policyData.data);
      }, error => {
        //System error
        this.currentStep = 0;
        this.systemError = true;
      }
    );
  }

  setUserPermissions(policy: any) {
    let permissions: any[] = [];
    permissions.push('ClaimFile');
    permissions.push('HVCM');
    this.userService.setUserPermissions(permissions);
    sessionStorage.setItem('policyDetails', JSON.stringify(policy));
    //Stored this so that user could continue to claim detail page
    this.userService.updateUserInfo({ policyNumber: this.policyNumber, userId: -1, isClaimsActive: true });
    this.router.navigate([`/happy-returns/claims`]);
  }

  cancel() {
    this.loading2 = false;
    this.verifyCodeError = false;
    this.confirmFormGroup.reset();
    this.currentStep = 0;
  }


}
